import React from 'react';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';

// This component assumes you have a logo.svg file in the assets folder
// If your file has a different name, replace 'logo.svg' with your file name

function Logo({ height = 80, to = '/', showText = true }) {
  return (
    <Box
      component={Link}
      to={to}
      sx={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: 'inherit',
        transition: 'transform 0.2s ease-in-out',
        '&:hover': {
          transform: 'scale(1.03)'
        }
      }}
    >
      <img 
        src="/logo.png" 
        alt="Logo" 
        style={{ 
          height: height,
          filter: 'drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.2))'
        }} 
      />
      {showText && (
        <Box
          component="span"
          sx={{
            ml: 1.5,
            fontWeight: 700,
            fontSize: '1.3rem',
            letterSpacing: '0.02em',
            display: { xs: 'none', sm: 'block' }
          }}
        >
          
        </Box>
      )}
    </Box>
  );
}

export default Logo; 